const ROOT_MARK = 'reader-mount'

const getNow = () =>
  typeof performance !== 'undefined' && typeof performance.now === 'function'
    ? performance.now()
    : Date.now()

const createTracker = () => {
  const marks = new Map()

  const mark = (name, detail = undefined, { once = false } = {}) => {
    if (!name) return null
    if (once && marks.has(name)) {
      return marks.get(name)
    }

    const now = getNow()
    if (!marks.has(name)) {
      marks.set(name, now)
    }

    const root = marks.get(ROOT_MARK) ?? now
    const offsetMs = Math.round(now - root)
    const prefix = `[AI startup] ${name} +${offsetMs}ms`

    if (detail !== undefined) {
      console.info(prefix, detail)
    } else {
      console.info(prefix)
    }

    return now
  }

  return {
    marks,
    mark,
    markOnce(name, detail) {
      return mark(name, detail, { once: true })
    },
    getMark(name) {
      return marks.get(name) ?? null
    },
  }
}

export const getAIToolStartupTracker = () => {
  if (typeof window === 'undefined') {
    return createTracker()
  }

  if (!window.__myeducatorAIToolStartup) {
    window.__myeducatorAIToolStartup = createTracker()
  }

  return window.__myeducatorAIToolStartup
}

export const initializeReaderAIBootstrap = ({
  coursenum,
  aiFeatures,
  voshiAppsVersion,
} = {}) => {
  if (typeof window === 'undefined') {
    return
  }

  if (!window.__myeducatorAIFeaturesByCourse) {
    window.__myeducatorAIFeaturesByCourse = {}
  }

  if (coursenum) {
    window.__myeducatorAIFeaturesByCourse[coursenum] = aiFeatures || {}
  }

  if (voshiAppsVersion) {
    window.__myeducatorVoshiAppsVersion = voshiAppsVersion
  }

  getAIToolStartupTracker().markOnce(ROOT_MARK, { coursenum })
}
